import React from 'react';
import logo from './../img/ABLogo_anim.gif';

/**
*Komponent pokazujący że dane progresbar informujący o ładowaniu danych
*/
export  function Loading(props) {
	return <div className="text-center" style={{width: '100%' }}>
		<img src={logo} style={{width: (props.width ? props.width : '128px'), paddingTop: (props.top ? props.top : '50px'), paddingBottom: (props.top ? props.top : '50px')}} />
	</div>
}